<script lang="ts" setup>
import LeftNavigation from '~/features-shared/left-panel/components/left-navigation.vue'
import { isPanelPinned } from '~/features-shared/left-panel/composables/left-panel-manager'
import { isTopBarLeftPanelOpened, isTopBarRightPanelOpened } from '~/features-shared/topframe/stores/states'

import { useFeatureManager } from '~/features-generic/config-manager/composables/feature-manager'

const route = useRoute()

const isNavBarActivated = useFeatureManager('layout.nav_bar')
const isLeftColumnActivated = useFeatureManager('layout.left_column')

const isLeftNavigationEnabled = computed(() => route.meta?.leftNavigation !== false)
const isLeftPanelEnabled = computed(() => route.meta?.leftPanel !== false)
</script>

<template>
  <div class="h-full print:!hidden">
    <div class="flex w-full h-full">
      <keep-alive>
        <LeftNavigation
          v-if="isLeftNavigationEnabled"
          :hide-left-panel="!isLeftPanelEnabled"
          layout="left"
        />
      </keep-alive>
      <main
        class="absolute l-0 w-full h-full overflow-x-hidden"
        :class="[{
          'with-nav-bar': isLeftNavigationEnabled && isNavBarActivated,
          'with-left-column': isLeftNavigationEnabled
            && ((isLeftColumnActivated && isPanelPinned && isLeftPanelEnabled) || isTopBarLeftPanelOpened),
          'with-right-column': isTopBarRightPanelOpened,
        }]"
      >
        <router-view v-bind="$attrs" />
      </main>
    </div>
  </div>
</template>
